import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '../../common/Input'
import { Button } from '../../common/Button'
import { StepHeader } from '../StepHeader'

interface LovedOneNameStepProps {
  initialValue?: string
  onNext: (value: string) => void
  onBack?: () => void
}

/**
 * Loved one name collection step (FR-011)
 */
export function LovedOneNameStep({ initialValue = '', onNext, onBack }: LovedOneNameStepProps) {
  const { t } = useTranslation()
  const [name, setName] = useState(initialValue)
  const [error, setError] = useState('')

  const handleNext = () => {
    if (!name || name.trim() === '') {
      setError(t('errors.required'))
      return
    }

    onNext(name.trim())
  }

  return (
    <div>
      <StepHeader type="loved-one" title="What is their name?" />

      <Input
        label={t('onboarding.lovedOne.nameLabel')}
        placeholder={t('onboarding.lovedOne.namePlaceholder')}
        value={name}
        onChange={e => {
          setName(e.target.value)
          if (error) setError('')
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleNext()
          }
        }}
        error={error}
        autoFocus
      />

      <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
        {onBack && (
          <Button variant="outline" onClick={onBack} style={{ flex: 1 }}>
            {t('onboarding.navigation.back')}
          </Button>
        )}
        <Button onClick={handleNext} style={{ flex: 1 }}>
          {t('onboarding.navigation.next')}
        </Button>
      </div>
    </div>
  )
}
